@if (!isActive()) {
  <button type="button" class="pomodoro-collapsed" (click)="toggleTimer()">
    <i class="i i-clock"></i>
    <span>Pomodoro Timer</span>
  </button>
} @else {
  <div class="pomodoro-card" [class.pomodoro-card--running]="!isPaused()">
    <button
      type="button"
      class="pomodoro-action"
      [title]="isPaused() ? 'Запустить' : 'Следующий этап'"
      (click)="togglePause()">
      <i class="i" [ngClass]="isPaused() ? 'i-play' : 'i-angle-double-right'"></i>
    </button>

    <div class="pomodoro-info">
      <div class="pomodoro-phase" [title]="phaseLabel()">{{ phaseLabel() }}</div>
      <div class="pomodoro-time">
        <span>
          @if (isPaused()) {
            {{ currentDuration() | number: '2.0-0' }}:00
          } @else {
            {{ remainingTime() | date: 'mm:ss' }}
          }
        </span>
        <span class="pomodoro-time__iteration" [title]="currentIteration() + ' of ' + totalIterations() + ' iterations'">
          {{ currentIteration() }}/{{ totalIterations() }}
        </span>
      </div>
    </div>

    <div class="pomodoro-controls">
      <button type="button" class="pomodoro-icon-btn" title="Настройки таймера" (click)="openSettingsModal()">
        <i class="i i-cog"></i>
      </button>
      <button type="button" class="pomodoro-icon-btn" title="Свернуть" (click)="toggleTimer()">
        <i class="i i-minus"></i>
      </button>
    </div>

    <div class="pomodoro-progress"><span [style.width.%]="progress()"></span></div>
  </div>
}
